import { useTranslation } from "react-i18next";
import React, { useContext, useEffect, useState } from "react";
import useMmcService from "../../services/MmcService";
import InitContext from "../pages/InitContext";
import ErrorMessage from "../errorMessage/ErrorMessage";
import Spinner from "../spinner/Spinner";
import Icd10Tree from "../disease/Icd10Tree";
import {Consts} from "../pages/consts";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faTrash} from "@fortawesome/free-solid-svg-icons";

const Diseases = ({ patientDiseases, onSetPatientDiseases, diseasesToShow, setPatientsDiseasesInDb }) => {
  const { t: t } = useTranslation();
  const context = useContext(InitContext);
  const { loading, error, clearError, getDiseasesJson, deleteDbDisease } = useMmcService();
  const [icd10Data, setIcd10Data] = useState([]);
  const [alreadyAddedError, setAlreadyAddedError] = useState(false);

  useEffect(() => {
    if (context?.token && context?.token !== "") {
      clearError();

      getDiseasesJson(context?.token).then((data) => {
        setIcd10Data(data);
      });
    }
  }, []);

  const handleDeleteDisease = (disease) => {
    if(disease?.id){ // the disease to delete was stored in the DB
      deleteDbDisease(context?.token, disease?.id).then((result) => {
        const newDiseases = diseasesToShow?.filter(d  => d?.id !== result?.id);
        setPatientsDiseasesInDb(newDiseases);
        onSetPatientDiseases([]);
      });
    } else { // the disease to delete is a new one, which is not yet stored in the DB
      const newDiseases = patientDiseases?.filter(d  => d?.icd10 !== disease?.icd10);
      onSetPatientDiseases(newDiseases);
    }
  };

  const errorMessage = error && <ErrorMessage message={t("error_by_retrieving_all_diseases")} />;
  const spinner = loading && <Spinner />;

  const localErrorMessage = alreadyAddedError && (
    <ErrorMessage message="The disease is already selected" />
  );

  return (
    <div>
      {localErrorMessage}
      <div className="w3-row">
        <div className="w3-col m8 form-content-scroll">
          <div className="w3-container w3-padding">
            <Icd10Tree
              data={icd10Data}
              patientDiseases={patientDiseases}
              onSetPatientDiseases={onSetPatientDiseases}
              closeDialog={() => {}}
              diseasesToShow={diseasesToShow}
              setAlreadyAddedError={(value) => setAlreadyAddedError(value)}
            />
          </div>
        </div>
        {diseasesToShow?.length > 0 && (
          <div className="w3-col m4">
            <div style={{ backgroundColor: "#FFFFE0", marginLeft: "12px" }}>
              <h2 style={{ padding: "12px" }}>{t("selected_diseases")}:</h2>
              <ul className="diseases-scroll" style={{ listStyleType: Consts.NONE, padding: "12px" }}>
                {diseasesToShow?.map((disease, i) => (
                  <li
                    key={`${disease?.icd10}-${i}`}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                      marginBottom: "10px",
                      justifyContent: "space-between",
                      width: "100%",
                    }}
                  >
                    <span style={{ minWidth: "150px" }}>
                      {disease?.icd10name} ({disease?.icd10})
                    </span>
                    <button
                      type="button"
                      onClick={() => handleDeleteDisease(disease)}
                      className="w3-btn w3-round-xlarge w3-theme-d5 "
                    >
                      <FontAwesomeIcon icon={faTrash} />
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        )}
      </div>
      {errorMessage}
      {spinner}
    </div>
  );
};

export default Diseases;
